import type { FC } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import FullscriptLogo from "@shared/assets/logo/fullscript-logo-green-background.png";
import { l } from "@unauthenticated/catalog/locales/i18n";

interface Props {
  title: string;
  description: string;
}

const SEOHelper: FC<Props> = ({ title, description }) => {
  const { t } = useTranslation();
  const formatString = str => {
    const removeHTMLRegex = /<[^>]*>/g;
    const formattedText = str?.replace(removeHTMLRegex, "")?.substring(0, 155);
    return formattedText;
  };

  return (
    <Helmet>
      <title data-testid="title-tag">{formatString(title)}</title>
      <meta data-testid="meta-title" property="og:title" content={formatString(title)} />
      <meta
        data-testid="meta-description"
        property="og:description"
        content={formatString(description)}
      />
      <meta name="description" content={formatString(description)} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="627" />
      <meta property="og:image" content={FullscriptLogo} />
      <meta property="og:type" content="website" />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:alt" content={t(l.seo.FullscriptAlt)} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@fullscriptHQ" />
      <meta name="twitter:title" content={formatString(title)} />
      <meta name="twitter:description" content={formatString(description)} />
      <meta name="twitter:image" content={FullscriptLogo} />
    </Helmet>
  );
};

export { SEOHelper };
